import { ChevronUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

type ItemsLimitSelectorProps = {
  limit: number;
  totalCount: number;
  onLimitChange: (limit: number) => void;
};

const ItemsLimitSelector = ({ limit, onLimitChange, totalCount }: ItemsLimitSelectorProps) => {
  const { t } = useTranslation();

  if (totalCount <= 10) {
    return null;
  }

  const items = [100, 50, 25, 10];

  const limitLabel = limit === 10 ? t('common.default') : limit;

  return (
    <div className="flex items-center gap-2">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            className="h-8 gap-1 font-normal border-border shadow-xs"
          >
            {limitLabel}
            <ChevronUp className="h-4 w-4 opacity-50" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-20">
          {items.map((value) => {
            const labelText = value === 10 ? `10 (${t('common.default')})` : value.toString();

            return (
              <DropdownMenuItem
                key={value}
                onClick={() => onLimitChange(value)}
                className={cn('font-normal', {
                  'bg-accent text-accent-foreground font-medium': limit === value,
                })}
              >
                {labelText}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default ItemsLimitSelector;
